'use client';

import { Css } from '@/ui';
import styled from '@emotion/styled';
import FeatureEntrypoint from '../../../components/common/cards/FeatureEntrypoint';
import CardsContainer from '../../../components/common/cards/CardsContainer';
import { HomeSection } from './HomeSection';
import Security from '../../../assets/icons/security.svg';
import Car from '../../../assets/icons/transport/car.svg';
import Shop from '../../../assets/icons/shop.svg';
import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { parkingBookingUrl } from '../../../config/common';

export const FeatureHomeSection = styled(HomeSection)`
	padding: ${Css.pxToRemFromTheme(24)} 0 40px;
`;

export default function FeatureEntryPointSection() {
	return (
		<FeatureHomeSection>
			<CardsContainer>
				<FeatureEntrypoint
					icon={<Security />}
					label="Security Information"
					href={PageRoutes.Security}
				/>

				<FeatureEntrypoint
					icon={<Shop />}
					label="Shop, Dine & Relax"
					href={PageRoutes.ShopDineRelax}
				/>

				<FeatureEntrypoint
					icon={<Car />}
					label="Parking Reservation"
					href={parkingBookingUrl}
				/>
			</CardsContainer>
		</FeatureHomeSection>
	);
}
